export enum MenuStyle {
	Icon = 'Icon',
	List = 'List'
}